@if (dailyFeedbackReportsAggregationData() && dailyFeedbackReportsDataCount()) {
  <div
    class="content"
    [style]="groupStyles()"
  >
    <div class="header">
      @for (column of headerColumns; track $index) {
        <div
          class="column"
          [class.no-border]="!column.id"
          [style.width]="column.width"
        >
          {{ column.name }}
        </div>
      }
    </div>
    <div class="line">
      <div class="line-title line-cell line-cell-aggregation">
        Всего за период
      </div>
      <app-daily-feedback-reports-row
        [isAggregationRow]="true"
        [data]="dailyFeedbackReportsAggregationData()!"
      />
    </div>
    <div>
      <div class="line">
        <div
          class="line-title line-cell"
        >
          По дням
        </div>
        <div class="line-days">
          @for (item of dailyFeedbackReportsData(); track $index) {
            <app-daily-feedback-reports-row
              [data]="item"
            />
          }
        </div>
      </div>
    </div>
  </div>
}
